import MultiTermListFacet from './MultiTermListFacet';

export default MultiTermListFacet;
